export default __webpack_public_path__ + "static/media/DummyTestimonalImg.fa630e20.png";